module.exports = __webpack_public_path__ + "img/ximilu.d8e1d687.png";